module.exports = __webpack_public_path__ + "img/icon-linkedin.304aa14a.svg";